import { BrowserRouter } from 'react-router'
import { AuthProvider, useAuth } from './auth/AuthProvider'
import AppShell, { Centered } from './pages/AppShell'
import LoginPage from './pages/LoginPage'

export default function App() {
  return (
    <AuthProvider>
      <Screen />
    </AuthProvider>
  )
}

function Screen() {
  const { state } = useAuth()

  if (state.status === 'loading') {
    return (
      <Centered>
        <p className="text-sm text-ink-500">Проверка сессии…</p>
      </Centered>
    )
  }

  if (state.status !== 'authenticated') {
    return <LoginPage />
  }

  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  )
}
